import type { FC } from "react";
import "./TaskItem.scss";

interface ITaskItemProps {
  id: number;
  taskTitle: string;
  onChangeTask: (id: number) => void;
  onDelete: (id: number) => void;
}

export const TaskItem: FC<ITaskItemProps> = ({
  id,
  taskTitle,
  onChangeTask,
  onDelete,
}) => {
  /* Удаление */
  const handleBtnDel = () => {
    onDelete(id);
  };
  /* Выполнено */

  const handleBtnChange = () => {
    onChangeTask(id);
  };

  return (
    <>
      <h3 className="task__item-title">{taskTitle}</h3>
      <div className="task__btn">
        <button className="task__btn-all task__btn_change" onClick={handleBtnChange} type="button">
          ...
        </button>
        <button className="task__btn-all task__btn_del" onClick={handleBtnDel} type="button">
          X
        </button>
      </div>
    </>
  );
};
